<template>
  <v-navigation-drawer right class="navigation-drawer" :value="dialog" width="400px" app>
    <template v-slot:prepend>
      <v-toolbar>
        <v-toolbar-title></v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="$emit('close', false)"> mdi-close </v-icon>
      </v-toolbar>
    </template>
    <v-card v-if="invoiceImg">
      <v-card-text class="pa-2 text-center">
        <v-img :src="invoiceImg"></v-img>
        <!-- QR ahora está integrado dentro del canvas de invoiceImg -->
      </v-card-text>
    </v-card>
    <template v-slot:append>
      <v-toolbar class="fixed-footer">
        <v-spacer></v-spacer>
        <v-btn
          color="success"
          @click="send_invoice(item.document.cufe)"
          v-if="
            hasDocumentData &&
            item.document.doc_type === 'invoice' &&
            item.buyer &&
            item.buyer.PartyEmail &&
            item.document.cufe
          "
        >
          Enviar Correo
        </v-btn>

        <v-spacer></v-spacer>
        <v-btn color="info" @click="print_doc()" :disabled="!invoiceImg">
          Imprimir
        </v-btn>
      </v-toolbar>
    </template>
  </v-navigation-drawer>
</template>

<script>
import createDoc from "@/utils/create_doc.js";
import settings from "@/utils/settings.js";
import { webserver, formatCurrency } from "@/services/webserver.js";
import createCompany from "@/utils/createCompany.js";

var QRCode = require("qrcode");

export default {
  props: {
    item: {
      type: Object,
      required: true,
      default: () => createDoc(),
    },
    dialog: {
      type: Boolean,
      required: true,
      default: false,
    },
    newInvoice: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mounted() {
    if (this.hasDocumentData) {
      // Initialize data if we have everything we need
      if (this.item && this.item.items && this.item.items.length > 0) {
        this.get_company();
      }
    }
  },
  data() {
    const settingsData = settings();
    return {
      fab: false,
      nc_dialog: false,
      nc_items: [],
      headers_nc: [
        {
          text: "Descripción",
          align: "start",
          sortable: true,
          value: "item_concept",
          dataType: "text",
        },
        {
          text: "Qty",
          align: "center",
          sortable: true,
          value: "item_quantity",
          dataType: "text",
          width: "10",
        },
        {
          text: "Precio",
          align: "end",
          sortable: true,
          value: "item_price",
          dataType: "number",
        },
        { text: "", align: "end", value: "actions", sortable: false, width: "5" },
      ],
      selected: [],
      invoiceImg: null,
      urlCufe: null,
      dian_dialog: false,
      dialog_mail: false,

      docview: "",
      loading_status: false,
      company: createCompany(),
      setting: settingsData,
      id_lst: settingsData["type_document_identifications"] || [],
      dialog_erros: false,
      dataURL: null,
    };
  },
  computed: {
    // Add computed properties to safely check for existence of nested properties
    hasDocumentData() {
      return this.item && this.item.document;
    },
    hasItems() {
      return this.item && this.item.items && this.item.items.length > 0;
    },
  },
  methods: {
    formatCurrency,
    get_company() {
      if (!this.item || !this.item.document || !this.item.document.store) {
        console.error("Missing required data for get_company");
        return;
      }

      var qry = {
        store: window.store.store_id,
        table: "f_companies",
        filters: [
          {
            field: "store_code",
            operator: "=",
            value: window.store.store_id,
          },
          {
            field: "store_business_id",
            operator: "=",
            value: window.store.store_business_id,
          },
        ],
      };
      this.loading_status = true;
      webserver("get_dataTable", qry, (data) => {
        this.loading_status = false;
        if (data && data.length > 0) {
          this.company = data[0];
        } else {
          console.warn("No company data found");
        }
      });
    },
    print_doc() {
      if (!this.dataURL) {
        console.error("No invoice image available");
        return;
      }

      var a = window.open("", "", "height=600, width=400");
      a.document.write('<img src="' + this.dataURL + '"  width="100%"/><br>');
      // QR ya está integrado en el canvas, no necesitamos imprimirlo por separado
      a.print();
      a.document.close();
      setTimeout(() => {
        a.close();
      }, 500);
    },

    print_invoice(data) {
      console.log(data);
      if (!data || !data.items) {
        console.error("Invalid data for print_invoice", data);
        return;
      }

      try {
        var LS = 50;
        var itemsQty = data.items.length * LS;

        // Create canvas
        var elem = document.createElement("canvas");
        elem.width = 945;
        elem.height = 3000 + itemsQty * 3;

        var center = elem.width / 2;
        var left = 10;
        var line = 50;
        var right = elem.width - left;
        const ctx = elem.getContext("2d");

        // Set monospace font for professional appearance (tomado de doc_viewer.vue)
        const titleFont =
          "bold 60px Consolas, 'Liberation Mono', 'Roboto Mono', monospace";
        const headerFont =
          "bold 40px Consolas, 'Liberation Mono', 'Roboto Mono', monospace";
        const normalFont =
          "bold 38px Consolas, 'Liberation Mono', 'Roboto Mono', monospace";
        const smallFont =
          "bold 35px Consolas, 'Liberation Mono', 'Roboto Mono', monospace";

        // Header content setup
        ctx.textAlign = "center";

        // Encabezado
        ctx.font = titleFont;
        ctx.fillText(data.company.PartyName || "", center, line);
        line += LS;

        ctx.font = headerFont;

        if (data.company && data.company.typeid) {
          ctx.fillText(
            this.get_name_typeId(data.company.typeid) +
              ": " +
              data.company.PartyIdentification,
            center,
            line
          );
        }
        line += LS;

        ctx.font = normalFont;
        if (data.company && data.company.AddressLine) {
          ctx.fillText(data.company.AddressLine, center, line);
        }
        line += LS;

        // Municipio y departamento
        const municipality = this.setting["municipalities"]?.find(
          (item) => item.id == data.company.city_code
        );
        if (municipality) {
          ctx.fillText(
            municipality.name + ", " + (data.company.Department || ""),
            center,
            line
          );
        }
        line += LS;

        // Título de documento
        line += LS;
        ctx.font = headerFont;
        if (data.document && data.document.doc_type) {
          const docTypeTitles = {
            FC: "FACTURA COMPLETA",
            FS: "FACTURA SIMPLIFICADA",
            NC: "NOTA CRÉDITO",
            TK: "TICKET",
            pos: "DOCUMENTO POS",
            stockIn: "AJUSTE DE ENTRADA A INVENTARIO",
            "CS-IN": "DOCUMENTO DE ENTRADA",
            "CS-OUT": "DOCUMENTO DE SALIDA",
          };
          ctx.fillText(
            docTypeTitles[data.document.doc_type] || "DOCUMENTO",
            center,
            line
          );
        } else {
          ctx.fillText("DOCUMENTO", center, line);
        }
        line += LS;

        // Número de documento
        if (data.document) {
          if (data.document.invoice) {
            ctx.fillText("No. " + data.document.invoice, center, line);
          } else if (data.document.doc_number) {
            ctx.fillText("No. " + data.document.doc_number, center, line);
          }
        }
        line += LS;

        // Fecha del documento
        if (data.document && data.document.issuedate) {
          ctx.fillText(data.document.issuedate, center, line);
        }
        line += LS * 2;

        // Datos de cliente
        ctx.textAlign = "start";
        ctx.font = normalFont;
        if (data.buyer) {
          if (data.buyer.PartyIdentification) {
            ctx.fillText(
              this.get_name_typeId(data.buyer.typeid) +
                ": " +
                data.buyer.PartyIdentification,
              left,
              line
            );
            line += LS;
          }

          ctx.fillText("Nombre / Razón Social: ", left, line);
          ctx.font = headerFont;
          line += LS;
          if (data.buyer.PartyName) {
            ctx.fillText(data.buyer.PartyName, left, line);
          }
          line += LS;

          if (data.buyer.PartyEmail) {
            ctx.fillText("Email: " + data.buyer.PartyEmail, left, line);
          }
        }
        line += LS * 2;

        // Lista de productos
        ctx.font = headerFont;
        ctx.textAlign = "center";
        ctx.fillText("Productos", center, line);
        line += LS;

        ctx.beginPath();
        ctx.moveTo(left, line - 10);
        ctx.lineTo(right, line - 10);
        ctx.stroke();
        line += LS;

        // Cabecera de productos
        var idx = 1;
        ctx.textAlign = "start";
        ctx.fillText("Item", left, line);
        ctx.textAlign = "start";
        ctx.fillText("Detalle", left + 120, line);
        ctx.textAlign = "end";
        ctx.fillText("Cant.", right - 200, line);
        ctx.textAlign = "end";
        ctx.fillText("Valor", right, line);
        line += LS;

        // Productos
        let total_base = 0;
        let total_iva = 0;
        let tdiscount = 0;

        data.items.forEach((row) => {
          // Cálculos para cada ítem
          let basePrice = row.item_price - (row.item_tax || 0);
          let itemTotalBasePrice = basePrice * row.item_quantity;
          let itemTotalTax = (row.item_tax || 0) * row.item_quantity;
          let discount = (row.item_discount || 0) * row.item_quantity;

          // Descripción del producto
          ctx.textAlign = "start";
          ctx.fillText(idx, left, line);
          ctx.fillText(row.item_concept || "", left + 50, line);

          // Nota adicional si existe
          if (row.item_note) {
            line += LS;
            ctx.textAlign = "start";
            ctx.fillText(row.item_note, left + 50, line);
          }

          line += LS;
          ctx.font = normalFont;
          ctx.textAlign = "start";
          ctx.fillText("Cod: " + (row.item_code || ""), left + 50, line);
          ctx.textAlign = "end";
          ctx.fillText(row.item_quantity || 0, right - 200, line);
          ctx.fillText(this.formatAmount(itemTotalBasePrice), right, line);

          // Mostrar impuestos y descuentos de forma genérica
          if (discount > 0) {
            line += LS;
            if (row.item_tax > 0) {
              let taxRate = (row.item_tax / basePrice) * 100;
              ctx.textAlign = "start";
              ctx.fillText(
                `Impuesto ${Math.round(taxRate)}%: ${this.formatAmount(
                  itemTotalTax
                )} / Descuento: ${this.formatAmount(discount)}`,
                left + 50,
                line
              );
            } else {
              ctx.textAlign = "start";
              ctx.fillText(`Descuento: ${this.formatAmount(discount)}`, left + 50, line);
            }
          } else if (row.item_tax > 0) {
            line += LS;
            let taxRate = (row.item_tax / basePrice) * 100;
            ctx.textAlign = "start";
            ctx.fillText(
              `Impuesto ${Math.round(taxRate)}%: ${this.formatAmount(itemTotalTax)}`,
              left + 50,
              line
            );
          }

          line += LS;
          ctx.font = headerFont;
          total_base += itemTotalBasePrice;
          total_iva += itemTotalTax;
          tdiscount += discount;
          idx++;
        });

        // Totales
        ctx.beginPath();
        ctx.moveTo(left, line - 10);
        ctx.lineTo(right, line - 10);
        ctx.stroke();
        line += LS;

        ctx.textAlign = "start";
        ctx.fillText("Base imponible", left, line);
        ctx.textAlign = "end";
        ctx.fillText(this.formatAmount(total_base), right, line);
        line += LS;

        if (total_iva > 0) {
          ctx.textAlign = "start";
          ctx.fillText("Impuestos", left, line);
          ctx.textAlign = "end";
          ctx.fillText(this.formatAmount(total_iva), right, line);
          line += LS;
        }

        if (tdiscount > 0) {
          ctx.textAlign = "start";
          ctx.fillText("Descuento aplicado", left, line);
          ctx.textAlign = "end";
          ctx.fillText("( " + this.formatAmount(tdiscount) + " )", right, line);
          line += LS;
        }

        ctx.textAlign = "start";
        ctx.fillText("TOTAL", left, line);
        ctx.textAlign = "end";
        ctx.fillText(this.formatAmount(total_base + total_iva), right, line);
        line += LS * 2;

        // Forma de pago
        ctx.textAlign = "start";
        ctx.fillText("Forma de pago: CONTADO", left, line);
        line += LS;
        ctx.textAlign = "center";
        ctx.fillText("Medio de pago", center, line);
        line += LS;

        // Información de pagos
        if (data.payments && data.payments.length > 0) {
          data.payments.forEach((payment) => {
            ctx.textAlign = "start";
            let paymentText = payment.payment_concept || "";
            if (payment.payment_reference) {
              paymentText += " " + payment.payment_reference;
            }
            ctx.fillText(paymentText, left, line);
            ctx.textAlign = "end";
            ctx.fillText(
              this.formatAmount(parseFloat(payment.payment_value || 0)),
              right,
              line
            );
            line += LS;
          });
        }

        line += LS;

        // Mensaje final
        ctx.textAlign = "center";
        ctx.fillText("¡Gracias por su compra!", center, line);
        line += LS;

        ctx.font = smallFont;
        line += LS;

        // Si hay CUFE, agregar código QR
        if (data.document && data.document.cufe) {
          ctx.textAlign = "center";
          ctx.font = headerFont;
          ctx.fillText("Huella digital (Signature Value):", center, line);
          line += 45;

          // Formato para el CUFE
          ctx.font = normalFont;
          const result = data.document.cufe.match(/.{1,38}/g) ?? [];

          // Fondo para el texto CUFE
          ctx.fillStyle = "rgba(240, 240, 240, 0.7)";
          const cufeBoxHeight = result.length * 35 + 20;
          ctx.fillRect(center - 400, line - 30, 800, cufeBoxHeight);
          ctx.fillStyle = "black"; // Restaurar color de relleno

          // Dibujar texto CUFE
          result.forEach((itm) => {
            ctx.fillText(itm, center, line);
            line += 35;
          });

          line += 20; // Espacio después del texto CUFE

          // Espacio para el código QR
          const qrY = line;
          line += 400 + 20; // Altura QR + padding

          // Generar y agregar el código QR
          QRCode.toDataURL(data.document.cufe, (err, url) => {
            this.urlCufe = url;
            const qrImg = new Image();
            qrImg.onload = () => {
              // Dibujar código QR
              ctx.drawImage(qrImg, center - 200, qrY, 400, 400);

              // Guardar resultado final después de dibujar el QR
              this.dataURL = elem.toDataURL();
              this.invoiceImg = this.dataURL;
              this.showPrint = true;
            };
            qrImg.src = url;
          });
        } else {
          // Si no hay CUFE, guardar la imagen sin QR
          this.dataURL = elem.toDataURL();
          this.invoiceImg = this.dataURL;
          this.showPrint = true;
        }
      } catch (error) {
        console.error("Error en print_invoice:", error);
      }
    },
    formatAmount(value) {
      return parseFloat(value)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    get_name_typeId(e) {
      console.log(this.id_lst);
      var index = this.id_lst.findIndex((itm) => itm.code === e);
      if (index >= 0) {
        return this.id_lst[index].name;
      } else {
        return "";
      }
    },
    get_e_doc() {
      if (!this.item || !this.item.document) {
        console.error("Missing document data");
        return;
      }

      var doc = {
        store: this.item.document.store,
        issueDate: this.item.document.issueDate,
        did: this.item.document.doc_number,
      };

      webserver("get_invoice_fe", doc, (data) => {
        if (data) {
          console.log("get_e_doc", data);
          this.print_invoice(data);
        } else {
          console.error("No data returned from get_invoice_fe");
        }
      });
    },

    get_e_doc_credit_note() {
      if (!this.item || !this.item.document) {
        console.error("Missing document data");
        return;
      }

      var doc = {
        store: this.item.document.store,
        issueDate: this.item.document.issueDate,
        did: this.item.document.doc_number,
      };

      webserver("get_invoice_fe", doc, (data) => {
        if (data) {
          this.e_credit_note(data);
        } else {
          console.error("No data returned from get_invoice_fe");
        }
      });
    },
  },
  watch: {
    item: {
      deep: true,
      handler(newValue) {
        console.log(newValue);
        this.print_invoice(newValue);
      },
    },
    dialog(newValue) {
      if (
        newValue &&
        this.item &&
        this.item.items &&
        this.item.items.length > 0 &&
        !this.invoiceImg
      ) {
        this.print_invoice(this.item);
      }
    },
  },
};
</script>

<style scoped>
.navigation-drawer {
  z-index: 1000;
}
.fixed-footer {
  bottom: 0;
  position: sticky;
}
</style>
